/* istanbul ignore file */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';

import { App, Project, Site } from '../../models';

@Injectable({
    providedIn: 'root'
})

export class SiteActivityLogDataService extends HttpBaseService {

    private baseRoute = environment.api + 'site-activity-log/';
    private route = this.baseRoute + 'app/';

    constructor(
        _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    getAllSiteActivityLog(app: App, site: Site, project: Project): any {
        const url = `${this.route}${app.id}/site/${site.id}/project/${project.id}`;
        return this.httpGet(url);
    }

}
